import { api, type RequestOptions } from "./client";

export interface AgentRunDto {
  id:                  string;
  agent_id:            string;
  status:              "running" | "completed" | "failed" | "cancelled" | "awaiting_human";
  trigger_type:        string;
  correlation_id:      string | null;
  started_at:          string;
  finished_at:         string | null;
  duration_ms:         number | null;
  error_message:       string | null;
  total_llm_calls:     number;
  total_cost_usd:      number;
  input_snapshot:      Record<string, unknown>;
  output_snapshot:     Record<string, unknown>;
}

export interface LLMCallDto {
  id:             string;
  task_type:      string;
  complexity:     string;
  provider:       string;
  model:          string;
  input_tokens:   number;
  output_tokens:  number;
  cost_usd:       number;
  latency_ms:     number;
  cache_hit:      boolean;
  finish_reason:  string | null;
  created_at:     string;
}

export interface AgentRunDetailDto extends AgentRunDto {
  llm_calls: LLMCallDto[];
}

export const agentRunsApi = {
  list(params: {
    limit?: number;
    agentId?: string;
    correlationId?: string;
  } = {}, opts?: RequestOptions): Promise<AgentRunDto[]> {
    const q = new URLSearchParams();
    q.set("limit", String(params.limit ?? 50));
    if (params.agentId)       q.set("agent_id",       params.agentId);
    if (params.correlationId) q.set("correlation_id", params.correlationId);
    return api.get<AgentRunDto[]>(`/agent-runs?${q.toString()}`, opts);
  },

  get(runId: string, opts?: RequestOptions): Promise<AgentRunDetailDto> {
    return api.get<AgentRunDetailDto>(`/agent-runs/${runId}`, opts);
  },
};
